/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryEditCommentRequest
 */
export interface RevisdomAPIViewModelsEntryEditCommentRequest {
    /**
     * Düzenlenecek comment'in ID'si
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryEditCommentRequest
     */
    id: number;
    /**
     * Comment'in yeni text'i
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryEditCommentRequest
     */
    text: string;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryEditCommentRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryEditCommentRequest(value: object): value is RevisdomAPIViewModelsEntryEditCommentRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function RevisdomAPIViewModelsEntryEditCommentRequestFromJSON(json: any): RevisdomAPIViewModelsEntryEditCommentRequest {
    return RevisdomAPIViewModelsEntryEditCommentRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryEditCommentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryEditCommentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'text': json['text'],
    };
}

export function RevisdomAPIViewModelsEntryEditCommentRequestToJSON(json: any): RevisdomAPIViewModelsEntryEditCommentRequest {
    return RevisdomAPIViewModelsEntryEditCommentRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryEditCommentRequestToJSONTyped(value?: RevisdomAPIViewModelsEntryEditCommentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'text': value['text'],
    };
}

